module.exports = __webpack_public_path__ + "img/title-ar.4225eb66.png";